import { useAuth0 } from '@auth0/auth0-react';
import React, { useState } from 'react';
import { Box, styled, TextField, Autocomplete } from '@mui/material';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import AwesomeDebouncePromise from 'awesome-debounce-promise';

const AutoSuggest = styled(Autocomplete)(({ theme }) => ({
    paddingRight: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
        width: '70%',
    },
}));
const SchoolImage = styled('img')(({ theme }) => ({
    'maxWidth': '30px',
    'width': '100%',
    'borderRadius': '20%',
    marginRight: '8px',
}));

const getSchoolList = (v, token) => {
    //baseURL: 'https://api-mgmt.airteachr.com.au',
    // const apiToken = 'API token';
    const schoolListItems = axios.get('/getSchoolList', {
        baseURL: process.env.REACT_APP_API_GATEWAY,
        timeout: 30000,
        headers: {
            // Authorization: apiToken,
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        params: {
            'search': v,
        },
    });
    return schoolListItems;
};
const searchAPIDebounced = AwesomeDebouncePromise(getSchoolList, 1200);
const AutoSuggestSchool = ({ searchSchool }) => {
    const [refreshToken, setRefreshToken] = useState({
        token: '',
        decoded: { exp: 0 },
    });
    const [schools, setSchools] = useState([]);
    const [schoolList, setSchoolList] = useState({
        loading: false,
        text: '',
        results: [],
    });
    const { getAccessTokenSilently } = useAuth0();
    const handleSchoolListSearch = async (e, v) => {
        if (
            v.length > 3 &&
            schoolList.results.findIndex(sch => sch.displayName === v) === -1
        ) {
            const schoolListValue = { loading: true, text: v, results: [] };
            setSchoolList(schoolListValue);

            if (Date.now() >= refreshToken.decoded.exp * 1000) {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                setRefreshToken({ token: token, decoded: jwt_decode(token) });
                const result = await searchAPIDebounced(v, token);

                const schoolListValue = {
                    loading: false,
                    text: v,
                    results: result.data.schools.Message.Data,
                };
                setSchoolList(schoolListValue);
            } else {
                const result = await searchAPIDebounced(v, refreshToken.token);
                const schoolListValue = {
                    loading: false,
                    text: v,
                    results: result.data.schools.Message.Data,
                };
                setSchoolList(schoolListValue);
            }
        } else if (v.length === 0) {
            setSchools([]);
        }
    };
    const selectSchool = (e, v) => {
        if (v !== null) {
            const sel = schoolList.results.find(sch => sch.pk1 === v.pk1);
            // console.log(sel.pk1, sel);
            searchSchool(sel);
            setSchools([]);
        }
    };
    return (
        <AutoSuggest
            id="search-school"
            data-cy="search-school"
            options={schoolList.results || ['']}
            sx={{ minWidth: '100%' }}
            getOptionLabel={option =>
                typeof option === 'string' ? option : option.displayName
            }
            includeInputInList
            filterSelectedOptions
            value={
                schoolList.results?.find(
                    school => school.pk1 === schools.pk1
                ) || null
            }
            filterOptions={x => x}
            loading={schoolList.loading}
            onInputChange={(event, newValue) =>
                handleSchoolListSearch(event, newValue)
            }
            onChange={(event, newValue) => selectSchool(event, newValue)}
            renderInput={params => (
                <TextField {...params} label="Search School" margin="normal" />
            )}
            renderOption={(props, option, { inputValue }) => {
                const matches = match(option.displayName, inputValue);
                const parts = parse(option.displayName, matches);

                return (
                    <li {...props}>
                        <Box>
                            <SchoolImage
                                loading="lazy"
                                src={option.schoolLogo}
                            ></SchoolImage>

                            {parts.map((part, index) => (
                                <span
                                    key={index}
                                    style={{
                                        fontWeight: part.highlight ? 700 : 400,
                                    }}
                                >
                                    {part.text}
                                </span>
                            ))}
                        </Box>
                    </li>
                );
            }}
        />
    );
};

export default AutoSuggestSchool;
